import libphonenumber from 'google-libphonenumber';

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatPhone = (phone?: string, noIntl?: boolean): string => {
  if (!phone) return '';

  try {
    const parsedNumber = phoneUtil.parse(phone, 'US');

    if (!phoneUtil.isValidNumber(parsedNumber)) {
      throw new Error('Invalid phone number');
    }

    const countryCode = parsedNumber.getCountryCode();

    if (countryCode === 1) {
      const national = phoneUtil.format(parsedNumber, libphonenumber.PhoneNumberFormat.NATIONAL);

      return noIntl ? national : `+1 ${national}`;
    }

    if (noIntl) {
      return phoneUtil.format(parsedNumber, libphonenumber.PhoneNumberFormat.NATIONAL);
    }

    return phoneUtil.format(parsedNumber, libphonenumber.PhoneNumberFormat.INTERNATIONAL);
  } catch {
    // Fallback to regex-based US formatting
    const cleaned = ('' + phone).replace(/\D/g, '');
    const usMatch = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (usMatch) {
      const intlCode = noIntl ? '' : '+1 ';

      return [intlCode, '(', usMatch[2], ') ', usMatch[3], '-', usMatch[4]].join('');
    }

    return phone;
  }
};

export const formatCurrency = (val?: number) => {
  return formatter.format(val || 0);
};

/**
 * Formats a decimal percentage value for display by multiplying by 100
 * Examples:
 * - 0.8 becomes "80%"
 * - 0.25 becomes "25%"
 * - 0.0025 becomes "0.25%"
 * @param val Percentage value as string or number (in decimal form)
 * @returns Formatted percentage string including the % symbol
 */
export const formatPercentage = (val?: string | number | null): string => {
  if (val === undefined || val === null || val === '') {
    return '0%';
  }

  const parsed = parseFloat(val.toString());

  const percentage = parsed * 100;

  return `${percentage.toString()}%`;
};
